/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { cssProps } from '@oracle/oraclejet-cssprops';
import { getCenterCoord } from '../utils/PRIVATE_meterUtils';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
type getCenterCoordParamType = Parameters<typeof getCenterCoord>;

export type CircularReferenceLineProps = {
  color?: ColorProps['color'];
  angle: number;
  radius: string;
  length: string;
  section: getCenterCoordParamType[0];
};

export function CircularReferenceLine({
  color,
  angle,
  radius,
  length,
  section = 'full'
}: CircularReferenceLineProps) {
  const centerCoord = getCenterCoord(section);
  const yOffset = `calc(${centerCoord.y * 100}% - ((${Math.sin(
    (angle * 2 * Math.PI) / 360
  )} * ${radius})))`;
  const xOffset = `calc(${centerCoord.x * 100}%  + ((${Math.cos(
    (angle * 2 * Math.PI) / 360
  )} * ${radius})))`;

  return (
    <div
      class={referenceLineStyles.base}
      style={{
        left: xOffset,
        top: yOffset,
        width: `calc(${length})`,
        transform: `translate(0, -1px) rotate(${360 - angle}deg)`,
        backgroundColor: color
          ? color
          : 'var(--oj-c-PRIVATE-DO-NOT-USE-dvt-reference-object-line-color)',
        borderBottom: '1px solid var(--oj-c-PRIVATE-DO-NOT-USE-dvt-contrast-line-color)'
      }}></div>
  );
}

const referenceLineStyles = {
  base: cssProps`${{
    height: '2px',
    position: 'absolute',
    transformOrigin: '0 50%',
    backgroundClip: 'padding-box'
  }}`
};
